import { SearchType } from 'features/SearchInput/types'

export const actions = {
  setHomeSearch: (homeSearch: SearchType) => ({ type: 'SEARCH__SET_HOME_SEARCH', search: { homeSearch } } as const)
}
